class PatternInfoTabPanel extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[id^="PatternInfoTabPanelTab-"]');
    this.activeTab = this.querySelector('[id^="PatternInfoTabPanelTab-"][active]');
    this.panes = this.querySelectorAll('[id^="PatternInfoTabPanelPane-"]');
    this.activePane = this.querySelector('[id^="PatternInfoTabPanelPane-"][active]');
    console.log(this.tabs, this.panes);

    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // this.showPane(tab);
        tab.setAttribute('active', '');
        this.activeTab.removeAttribute('active');
        this.activeTab = tab;

        const pane = this.getPaneById(tab.id.split('-')[1]);
        pane.setAttribute('active', '');
        this.activePane.removeAttribute('active');
        this.activePane = pane;
      });
    });
  }

  getPaneById(id) {
    return this.querySelector(`[id="PatternInfoTabPanelPane-${id}"]`);
  }
}
customElements.define('pattern-info-tab-panel', PatternInfoTabPanel)